import { ImageElement } from "@kontent-ai/gatsby-components";
import { ImageElementProps } from "@kontent-ai/gatsby-components/dist/image-element";
import React from "react";

export const KontentImageElement: React.FC<ImageElementProps> = (props) => {
  if (!props.image?.url) return null;
  return <ImageElement {...props} />;
};
